module.exports = __webpack_public_path__ + "img/venice1.9afb95dd.jpg";